import { render, staticRenderFns } from "./qrCodeWrap.vue?vue&type=template&id=5af364e0&scoped=true&"
import script from "./qrCodeWrap.vue?vue&type=script&lang=js&"
export * from "./qrCodeWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af364e0",
  null
  
)

export default component.exports